var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isCheckAgeNeeded
    ? _c(
        "div",
        { class: { error: _vm.showError }, attrs: { className: "checkout" } },
        [
          _c(
            "label",
            { attrs: { htmlFor: "checkAge", className: "form-check-label" } },
            [
              _vm._v(
                _vm._s(_vm.$translate("KrauseSohn::Template.checkout18Check"))
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }